import { useEappStore } from "#src/stores/electronic-application.js";
import { parseErrorMessage } from "#src/util/helpers.js";

export class EappsService {
  #pinia;
  constructor(pinia) {
    this.#pinia = pinia;
  }

  async fetchEapp({ uuid }) {
    const eApp = useEappStore(this.#pinia);

    if (!uuid) throw { errors: { error: ["Missing required params"] } };

    eApp.uuid = uuid;

    // instead of requiring birthdate, use API Key
    try {
      const eapp = await eApp.fetchEapp({ advisorCheck: false });
      return eapp;
    } catch (e) {
      throw { errors: { error: [parseErrorMessage(e)] } };
    }
  }

  createEapp(quote = {}) {
    const eApp = useEappStore(this.#pinia);
    return eApp.createElectronicApplication(quote, {
      created_without_quote: !quote?.id,
    });
  }
}
